import React, { useEffect } from 'react';
import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import MetaFormFields from 'Views/Onboarding/Pages/Survey/SurveyStep/Components/MetaFormFields';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import RoundedButton from 'Components/ComponentLibrary/Atoms/Inputs/RoundedButton';
import CenteredActions from 'Views/Page/Content/Modal/Components/CenteredActions';
import { dispatchModalContextSubmissionSuccessful } from 'Hooks/useRefreshEvent';
import { useSnackbarContext } from 'Context/SnackbarContext';

const Layout = () => {
  const {
    clearModalCollection,
  } = useModalContext();

  const { displaySuccess, displayErrorMessage } = useSnackbarContext();

  const {
    errors,
    resource,
    onSubmit,
  } = useMetaLayoutContext();

  const handleSubmit = async () => {
    try {
      const resp = await onSubmit();

      if (resp) {
        clearModalCollection();
        displaySuccess('Task Updated');
        dispatchModalContextSubmissionSuccessful();
      }
    } catch (err) {
      displayErrorMessage(err, err.errors);
    }
  };

  // Must display error via useEffect because onSubmit does not throw if there is an error. Instead,
  // it sets errors in the context.
  useEffect(() => {
    if (errors.length > 0) {
      displayErrorMessage(errors[0], errors[0].detail);
    }
  }, [errors]);

  return (
    <Box>
      <MetaFormFields
        resource={resource}
      />
      <CenteredActions>
        <RoundedButton
          fullWidth
          onClick={handleSubmit}
        >
          {'Submit'}
        </RoundedButton>
      </CenteredActions>
    </Box>
  );
};

export default Layout;
